import { WarrantyContract } from './contract.model';
import { Product } from './product.model';
import { Tenant } from './tenant.model';
import { Report } from './report.model';
import { CustomForm } from './custom-form.model';
import { Quote } from './quote.model';
import { Authorization } from './authorization.model';
import { Commission } from './commission.model';
import { Property } from './property.model';
import { Broker } from './broker.model';
import { Document } from './document.model';
import { Payments } from './payments.model';
import { ID } from './ID.model';

export type WarrantyStatus = 'DOCUMENTACION' | 'PAGO_PENDIENTE' | 'GENERAR_CONTRATO' | 'AUTORIZACION_PENDIENTE' | 'FIRMA_DIGITAL' | 'FIRMA_PENDIENTE' | 'ACTIVA' | 'FINALIZADA' | 'BAJA_ANTICIPADA' | 'BAJA_POR_ADMIN' | 'BAJA_POR_AGENTE';

export interface Warranty extends Product {
    hash: string;
    motivoBaja?: string;
    fechaActualizacion?: string;
    fechaCreacion?: string;
    creadoPor?: string;
    actualizadoPor?: string;
    idInquilinoPrincipal: ID;
    agente?: Broker;
    propiedad?: Property;
    comisionAgente?: Commission;
    capturasFirmaContrato?: Document[];
    cotizacion: Quote;
    inquilinos: Tenant[];
    estado: WarrantyStatus;
    informe: Report;
    formularios?: CustomForm[];
    autorizaciones: Authorization[];
    pagos?: Payments;
    contratos?: WarrantyContract;
}

export function getWarrantyEmail(warranty: Warranty) {
    return warranty.inquilinos.find(i => i.id === warranty.idInquilinoPrincipal)?.email;
}
